import { useRef, useState } from 'react';
import { AboutThisPagePanel } from './AboutThisPagePanel.jsx';
import './aboutThisPage.css';

// "About this page" opener (WP5 SME onboarding).
//
// A compact round "ⓘ About" control rendered in the TopBar next to the page
// title. It owns the open/close state for the contextual About drawer and only
// mounts the panel — and therefore only triggers the panel's lazy content
// import — once the user actually opens it. Nothing about the (larger) content
// bundle is pulled into the TopBar's synchronous import graph.
export function AboutThisPageButton() {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  return (
    <>
      <button
        type="button"
        className="about-this-page-btn"
        data-testid="about-this-page"
        data-tour="about-this-page"
        aria-label="About this page"
        aria-haspopup="dialog"
        aria-expanded={open}
        title="About this page"
        ref={buttonRef}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="about-this-page-icon" aria-hidden>
          &#9432;
        </span>
        <span className="about-this-page-label">About</span>
      </button>
      {open ? (
        <AboutThisPagePanel onClose={() => setOpen(false)} returnFocusRef={buttonRef} />
      ) : null}
    </>
  );
}
